<template>
  <main-toolbar>
    <div class="sales-select-box-wrapper">
      <div>
        <search-select-auto-complete
          v-model="innerValue.rentalcompanyId"
          :items="companyOptions"
          :label="'업체' | translate"
          class="sales-select-box-style"
          :error="!innerValue.rentalcompanyId"
        />
        <div v-if="!innerValue.rentalcompanyId" class="rental-error-message ml-2">
          입대업체명을 선택해주세요!
        </div>
      </div>
      <select-box-multi-check
        v-model="innerValue.serviceCdList"
        :items="paymentMethodOptions"
        :label="'납입방법' | translate"
        class="sales-select-box-style"
      />
      <select-box-multi-check
        v-model="innerValue.paymentStatusList"
        :items="paymentStatusOptions"
        :label="'납입현황' | translate"
        class="sales-select-box-style"
      />
      <select-box-multi-check
        v-model="innerValue.cmsList"
        :items="cmsOptions"
        :label="'CMS' | translate"
        class="sales-select-box-style"
      />
      <select-box-multi-check
        v-model="innerValue.salesTypeList"
        :items="salesTypeOptions"
        :label="'매출유형' | translate"
        class="sales-select-box-style"
      />
      <select-box-multi-check
        v-model="innerValue.billDayList"
        :items="billDayOnlyNumberOptions"
        :label="'결제일' | translate"
        class="sales-select-box-style"
      />
      <select-box-single-check
        v-model="innerValue.deleteYn"
        :items="[
        {codeValue: '전체', codeKey: null},
        {codeValue: '삭제', codeKey: 'Y'},
        {codeValue: '미삭제', codeKey: 'N'},]"
        :label="'삭제여부' | translate"
        class="sales-select-box-style"
        :clearable="false"
      />
      <select-box-month-picker
        v-model="innerValue.startDate"
        title="시작월"
      />
      <select-box-month-picker
        v-model="innerValue.endDate"
        title="종료월"
      />
    </div>
  </main-toolbar>
</template>

<script>

import MainToolbar from "@/components/common/layout/MainToolbar";
import SelectBoxMonthPicker from "@/components/selectBox/SelectBoxMonthPicker";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions";
import SelectBoxMultiCheck from "@/components/selectBox/SelectBoxMultiCheck";
import SearchSelectAutoComplete from "@/components/selectBox/SearchSelectAutoComplete";
import SelectBoxSingleCheck from "../../components/selectBox/SelectBoxSingleCheck.vue";

export default {
  name: "SearchGroupSales",
  components: {
    SelectBoxSingleCheck,
    MainToolbar,
    SelectBoxMonthPicker,
    SelectBoxMultiCheck,
    SearchSelectAutoComplete
  },
  mixins: [TotalCodeOptions],
  props: {
    selectOptions: {
      type: Object
    },
  },
  data() {
    return {
      innerValue: undefined,
    }
  },

  watch: {
    selectOptions: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.innerValue = newValue
      }
    },
    innerValue: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.$emit('update:select-options', newValue)
      }
    }
  },
  created() {
    /**
     * 필더 목록 가져오는 함수
     * codeValue와 CodeKey 요소로 이뤄진 객체
     * TotalCodeOptions.vue 참고
     *
     */
    this.loadCmsOptions();
    this.loadPaymentMethodOptions();
    this.loadPaymentStatusOptions();
    this.loadSalesTypeOptions();
    this.loadBillDayOnlyNumberOptions();
    this.loadCompanyOptions();
  },
}
</script>

<style scoped>
.sales-select-box-wrapper {
  display: flex;
  height: 50px;

}

.sales-select-box-style {
  width: 140px;
  margin: 2px
}

.rental-error-message {
  font-size: 10px;
  margin-top: 35px;
  text-align: left;
  color: #ff5252 !important
}

.main-toolbar[data-v-6772237e] {
  margin-bottom: 0px
}

>>> .v-input__control {
  width: 10px;
  height: 10px;
}

/* Select Box 에서 height부분 */
>>> .v-input__control .v-input__slot fieldset {
  height: 47px;
}

/* Select Box 에서 X 아이콘 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-icon {
  font-size: 19px;
}

/* Select Box 에서 label font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-label {
  font-size: 12px;
}

/* Month Select Box 에서 label font 부분 */
>>> .v-input__control .v-input__slot .v-text-field__slot .v-label {
  font-size: 12px;
}

>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections {
  padding: 0;
}

/*single Select Box 에서 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection {
  font-size: 12px;
  margin: 0;
}

/*Multi Select Box 에서 font 부분 */
>>> .v-input__control .v-input__slot .v-select__slot .v-select__selections .text-truncate {
  font-size: 12px;
  margin: 0;
}

/*SearchSelectBox 에서 font 부분입니다.*/
>>> .v-select.v-text-field input {
  font-size: 12px !important;
  margin: 0 !important;
}
</style>